import api from '@/lib/api/axios'
import type { ScanStatusChange } from '@/lib/utils/scan-status-change'

/** A person changing a version's scan status (to green, amber or red): one requests, a different one approves. */
export const scanStatusApi = {
    /** `acceptReference`: also accept this scan as the object's new reference (only where the scan left one to accept). */
    request: (versionId: number, newStatus: number, reason: string, acceptReference = false) =>
        api.post<{ data: ScanStatusChange }>('/api/scan-status-changes', { versionId, newStatus, reason, acceptReference }),
    approve: (id: number, note?: string) =>
        api.post<{ data: ScanStatusChange }>(`/api/scan-status-changes/${id}/approve`, { note }),
    /** A second person refusing it, or the requester taking it back - the server decides which. */
    reject: (id: number, note?: string) =>
        api.post<{ data: ScanStatusChange }>(`/api/scan-status-changes/${id}/reject`, { note }),
    revoke: (id: number, reason: string) =>
        api.post<{ data: ScanStatusChange }>(`/api/scan-status-changes/${id}/revoke`, { reason }),
}
